import { render, staticRenderFns } from "./JColourTag.vue?vue&type=template&id=18a13683"
import script from "./JColourTag.vue?vue&type=script&lang=js"
export * from "./JColourTag.vue?vue&type=script&lang=js"
import style0 from "./JColourTag.vue?vue&type=style&index=0&id=18a13683&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports